import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  ProfileAccountInfo,
  ProfileAccountInfoFromServer,
} from "api/interfaces/accountInterface.interface";
import { LEVEL_TYPE } from "api/interfaces/commonInterface.interface";
import { BILLING_TYPE } from "api/interfaces/planInterface.interface";
import { BILLING_CYCLE } from "api/interfaces/subscription.interface";
import { initialUserData } from "components/Auth";
import { SUSPENSION_STATUS } from "redux/stomp/stompSubscriptionSlice";

import {
  checkedUserAdmin,
  checkOnlyAdminGroup,
  checkPermission,
  CheckPermissionParamType,
  isHiddenGroup,
  checkIsSuspended,
  checkIsSubCP,
} from "utils/AccountUtil";

// ProfileAccountInfo type 으로 변경 - redux 용 account 정보로 변경
export const changeToAccountFormat = (
  account: ProfileAccountInfoFromServer
): ProfileAccountInfo => {
  return {
    ...account,
    isAdminGroup: checkOnlyAdminGroup(account.userPermission), // admin group 에 속해있는 user
    checkedUserAdmin: checkedUserAdmin(account.userPermission), // admin 기능만 할 수 있는 user
    userPermission: checkPermission(account as CheckPermissionParamType),
    isHidden: isHiddenGroup(account.userPermission),
    isSuspended: checkIsSuspended(account),
    isEnabled: checkIsSuspended(account) === SUSPENSION_STATUS.ENABLED,
    isOnlyCustomUser:
      !checkOnlyAdminGroup(account.userPermission) &&
      account.userPermission.length >= 2,
    cycle: account.cycle ?? BILLING_CYCLE.MONTHLY,
    isUsagePaid: account.isPayment,
    accountLevelExtendSubCp: checkIsSubCP(account)
      ? LEVEL_TYPE.SP
      : account.accountLevel,
    // && account.billingType === BILLING_TYPE.USAGE,
  };
};

export const initialState: ProfileAccountInfo = {
  ...changeToAccountFormat(initialUserData.accounts),
  userPermission: {
    enableAllPermissions: false,
    manageAlertRules: false,
    viewAlerts: false,
    manageUsersAndGroups: false,
    viewUsersAndGroups: false,
    manageReportRules: false,
    viewReports: false,
    manageRecordersAndGroups: false,
    viewRecordersAndGroups: false,
    manageAccount: false,
    viewAccount: false,
    view: false,
    manageBillingAndLicenses: false,
    subscriptionOrganization: false,
    suspend: false,
    lowLevelAccess: false,
    subscriptionKeys: false,
    generateKeys: false,
    serviceAndPricing: false,
    serviceAndPricingUpdate: false,
    cumulus: false,
    generateCumulus: false,
    viewSubscription: false,
    manageSubscription: false,
    announcement: false,
    logging: false,
    releaseNotes: false,
    manageMaintenance: false,
  },
};

// 사용자 로그인 후 Account 정보와 선택정보를 전역으로 관리.
export const accountSlice = createSlice({
  name: "accountSettings",
  initialState,
  reducers: {
    setAccountSetting(
      state,
      action: PayloadAction<ProfileAccountInfoFromServer>
    ) {
      let tmpInfo = {
        ...changeToAccountFormat(action.payload),
      };
      if (window.dataLayer) {
        window.dataLayer.push({
          event: "dw_account_setting",
          account_id: action.payload.accountId,
          account_name: action.payload.accountName,
          account_level: action.payload.accountLevel,
        });
      }

      const newState: ProfileAccountInfo = Object.assign({}, tmpInfo);
      return newState;
    },
    updateAccountThumbnail(state, action: PayloadAction<string>) {
      state.companyLogo = action.payload;
    },
    purgeAccount(state, action) {
      return initialState;
    },
  },
});

export const { setAccountSetting, purgeAccount } = accountSlice.actions;

export default accountSlice;
